import React, { PropTypes } from 'react';

const DEFAULT_ICON = 'espn-default';

const Logo = ({ className, iconHref = DEFAULT_ICON }) => {
    if (iconHref.indexOf('http://') === -1) {
        return <div className={`${className} icon-font-before icon-${iconHref || DEFAULT_ICON}-solid-before`} />;
    }
    return (
        <div className={className}>
            <img src={iconHref} className="imageLoaded" alt="sport icon" />
        </div>
    );
};

Logo.propTypes = {
    className: PropTypes.string,
    iconHref: PropTypes.string
};

export default Logo;



// WEBPACK FOOTER //
// ./app/common/Logo.js